export const isIOS =
  process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
